import React from "react";
import ContainerWrapper from "./ContainerWrapper";
import HowToMain from "Components/HowTo/HowToMain";

// const HowToMain = React.lazy(() => import("Components/HowTo/HowToMain"));

const HowTo = () => {
  return (
    // <ContainerWrapper>
    <HowToMain />
    // </ContainerWrapper>
  );
};

export default HowTo;
